import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LocalizationService, LocalizationModule, SubscriptionService } from '@abp/ng.core';
import { ColDef } from '@ag-grid-community/core';
import {
  BaseDapperListPage,
  DwGridDataSourceService,
  FieldTypes,
  IEnumerationCellRendererParams,
} from '@digiwall/ag-grid';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { GoliathCoreEnumerationTypeStore } from '@digiwall/goliath-core';
import { LanguageStore } from '@digiwall/core';
import { DocTemplateListDto, DocTemplateService } from '@digiwall/goliath-documents/proxy';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';
import { GoliathDocumentEntityNames } from '../../../constants/entity-names.constants';

@Component({
  selector: 'document-doc-template-list',
  templateUrl: './doc-template-list.component.html',
  styleUrl: './doc-template-list.component.scss',
  providers: [DwGridDataSourceService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class DocTemplateListComponent extends BaseDapperListPage<
  DocTemplateListDto,
  DocTemplateService
> {
  enumerationTypeStore = inject(GoliathCoreEnumerationTypeStore);
  languageStore = inject(LanguageStore);
  protected GoliathDocumentEntityNames = GoliathDocumentEntityNames;

  columns: ColDef[] = [
    {
      field: 'isActive',
      headerName: this.localizationService.instant('::IsActive'),
      type: FieldTypes.Boolean,
    },
    {
      field: 'uniqueCode',
      headerName: this.localizationService.instant('::UniqueCode'),
      type: FieldTypes.String,
    },
    {
      field: 'name',
      headerName: this.localizationService.instant('::Name'),
      type: FieldTypes.String,
    },
    {
      field: 'languageId',
      headerName: this.localizationService.instant('::Language'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.languageStore.entities,
      } as IEnumerationCellRendererParams,
    },
    {
      field: 'note',
      headerName: this.localizationService.instant('::Note'),
      type: FieldTypes.String,
    },
  ];

  constructor(
    protected router: Router,
    private docTemplateService: DocTemplateService,
    protected route: ActivatedRoute,
    private confirmation: ConfirmationService,
    private localizationService: LocalizationService,

    subscriptionService: SubscriptionService,
    datasource: DwGridDataSourceService,
  ) {
    super(docTemplateService, route, router, confirmation, subscriptionService, datasource);
  }
}
